import Vue from 'vue'
import Router from 'vue-router'
import ErrorPage from '@/js/modules/errorPages/errorpage'
import NORightPage from '@/js/modules/errorPages/norightpage'
import ProjectDetail from '@/js/modules/project/ui/etl_project/project_detail/ProjectDetail'
import SearchProject from '@/js/modules/search/searchProject'
import LoginPage from '@/js/modules/login/loginpage'
import Main from '@/js/modules/main'
import PersonInfo from '@/js/modules/personinfo/personinfo'
import Workerbench from '@/js/modules/project/ui/etl_project/project_list/Workerbench'
import HistoryWorkerbench from '@/js/modules/project/ui/etl_project/project_history_list/Workerbench'
import ViewReportDetail from '@/js/modules/project/ui/etl_project/project_detail/ViewReportDetail'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [{
    name: 'index',
    path: '/',
    component: Main,
    children: [{
        name: 'workerbench',
        path: '/workerbench',
        component: Workerbench,
      }, {
        name: 'history-workerbench',
        path: '/workerbench/history',
        component: HistoryWorkerbench,
      }, {
        name: 'project-detail',
        path: '/project-detail',
        component: ProjectDetail
      }, {
        path: '/searchProject',
        name: 'searchProject',
        component: SearchProject
      }, {
        path: '/norightPage',
        name: 'norightPage',
        component: NORightPage
      }, {
        name: 'login',
        path: '/login',
        component: LoginPage,
      }
    ]
  }, {
  	path: '/view-report',
    component: ViewReportDetail,
    name: 'view-report',
  }, {
    name: 'base_info',
    path: '/base_info/:id',
    component: PersonInfo
  }, {
    path: '*',
    component: ErrorPage,
    meta: {
      title: '页面没找到'
    }
  }]
})

export {
  router
}



// WEBPACK FOOTER //
// ./src/js/router/index.js